export enum OwnerTypes {
  individual = 'Individual',
  company = 'Company'
}
